module.exports = __webpack_public_path__ + "img/logo-ups.e753cb7d.svg";